import {
  FieldValues,
  UseFormProps,
  useForm as useHookForm
} from 'react-hook-form'

export const useForm = <
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object
>(
  props?: UseFormProps<TFieldValues, TContext>
) => {
  const values = useHookForm<TFieldValues, TContext>(props)
  const getError = (name: keyof TFieldValues) => {
    return values.formState.errors[name]?.message
  }

  return { ...values, getError }
}
